module.exports = __webpack_public_path__ + "static/img/nav_bg.104bcde.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav_bg.png
// module id = /88t
// module chunks = 1